import TableObjectAPIService from './TableObjectAPIService';
import { registerAsfTableObjectDirective } from './TableObjectDirective';
import registerTableObjectStepOneDirective from './TableObjectStep1Directive';
import TableObjectStepTwoDirective from './TableObjectStep2Directive';
import registerTableObjectStepThreeDirective from './TableObjectStep3Directive';
import registerHandsontableRichtextEditor from './HandsontableRichtextEditor';

export default function registerTableObjectDirectives(angular) {
    angular.module('assessmentFrontendServices').service('TableObjectAPIService', ['$q', TableObjectAPIService]);
    registerTableObjectStepOneDirective(angular.module('assessmentFrontendDirectives'));
    angular.module('assessmentFrontendDirectives').directive('tableObjectStepTwo', ['$translate', function($translate) { return new TableObjectStepTwoDirective($translate).directive($translate); }]);
    registerTableObjectStepThreeDirective(angular.module('assessmentFrontendDirectives'));
    registerAsfTableObjectDirective(angular.module('assessmentFrontendDirectives'));
    registerHandsontableRichtextEditor();
}